import { createContext, useContext } from "react";
import { TFormBuilderEntityDomNodeRefMap } from "./hooks/entityDomNodeRefMap/useFormBuilderEntityDomNodeRefMapRegistration";
import { IFormBuilderController } from "./controller/useFormBuilderController";

interface IFormBuilderEditorContext {
  panelRef: React.MutableRefObject<HTMLDivElement>;
  formBuilderController: IFormBuilderController;
  formRef: React.MutableRefObject<HTMLDivElement>;
  formBuilderEntityDomNodeRefMap: TFormBuilderEntityDomNodeRefMap;
}

const defaultFormBuilderEditorContext: IFormBuilderEditorContext = {
  panelRef: null,
  formBuilderController: null,
  formRef: null,
  formBuilderEntityDomNodeRefMap: null,
};

export const FormBuilderEditorContext = createContext<IFormBuilderEditorContext>(defaultFormBuilderEditorContext);
export const useFormBuilderEditorContext = () => useContext(FormBuilderEditorContext);
